import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import callLoginApi from "./callLoginApi.js";
import callLogoutApi from "./callLogoutApi.js";
import callCreatePasswordApi from "./callCreatePasswordApi.js"
import callAssignedJobs from "./callAssignedJobs.js";
import getmasterData from "./getMasterData.js";
import cancelHoldJob from "./cancelHoldJob.js";
import getcompletedjobs from "./getcompletedjobs.js";
import callShippingJobs from "./callShippingJobs.js";
import callOrderShippingJobs from "./callOrderShippingJobs.js";
import cancelTripOrder from "./cancelTripOrder.js";
import callSetDeliveredOrder from "./callSetDeliveredOrder.js";
import delayTrip from "./delayTrip.js";
import endTrip from "./endTrip.js";
import feedback from "./feedback.js";
import getpendingAmountResult from "./getpendingAmount";
import markinoutApi from "./markinoutApi";
import holdreasonApi from "./holdreasonApi";
import resheduleApi from "./resheduleApi";
import notifyapi from "./notifyapi";
import getListOfStore from "./getAllStore";
import updateriderstatus from "./updateRiderStatus";
import completedviewdetails from "./completeViewDetails";
import delayreasonsList from "./getdelayReasons";
import holdreasonsList from "./getholdReasons";
import getReturnReasons from "./getReturnReasons";
import returnReasonPost from "./returnReasonPost";
import getRescheduleReason from "./getscheduleReasons";
import getNotifyReason from "./getnotifyReasons";
import rejectRiderTrip from "./rejectRiderTrip";
import acceptJobList from "./acceptJobList";
import riderAcceptedJob from "./riderAcceptedJob";
import callRiderViewApi from "./callRiderViewApi";
import callPartialReturnOrderItem from "./callPartialReturnOrderItem";
import riderCashPayment from "./riderCashPayment";
import cancelJob from "./cancelJob";
import getCancelResonsList from "./getCancelResonsList";
import holdOrders from "./holdOrders";
import changeOrderToInTransit from "./changeOrderToInTransit";
import changeOrderToReject from "./changeOrderToReject";
import isUserActive from "./isUserActive"
export default {
  callLoginApi,
  callCreatePasswordApi,
  isUserActive,
  callLogoutApi,
  acceptJobList,
  callAssignedJobs,
  getmasterData,
  cancelHoldJob,
  getcompletedjobs,
  callShippingJobs,
  callOrderShippingJobs,
  cancelTripOrder,
  delayTrip,
  endTrip,
  getRescheduleReason,
  callSetDeliveredOrder,
  feedback,
  getpendingAmountResult,
  markinoutApi,
  holdreasonApi,
  resheduleApi,
  getListOfStore,
  updateriderstatus,
  notifyapi,
  completedviewdetails,
  delayreasonsList,
  holdreasonsList,
  getReturnReasons,
  returnReasonPost,
  getNotifyReason,
  rejectRiderTrip,
  riderAcceptedJob,
  callRiderViewApi,
  riderCashPayment,
  callPartialReturnOrderItem,
  cancelJob,
  getCancelResonsList,
  holdOrders,
  changeOrderToInTransit,
  changeOrderToReject,
};



// WEBPACK FOOTER //
// ./src/utility/api/api.js